import React from "react";
import { Routes, Route } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import AdminLayout from "layouts/Admin.js";
import SignIn from "./views/Login/SignIn";
import HomePage from "./views/Home/Landing";
import Loader from "components/Loader/Loader";
import ProtectedRoute from "./components/AuthGuard";
import { ToastContainer } from "react-toastify";
import configureStore from "./config";
import ForgotPassword from "views/ForgotPassword/ForgotPassword";
import VerifyOtp from "views/VerifyOtp/VerifyOtp";
import ResetPassword from "views/ResetPassword/ResetPassword";
import TermsCondition from "views/TermsCondition/Terms";
import PrivacyPolicy from "views/PrivacyPolicy/PrivacyPolicy";
import { QueryClient, QueryClientProvider } from "react-query";

const App = () => {
  const { persistor, store } = configureStore();
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<TermsCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            
            {/* Protected Routes */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
          <ToastContainer autoClose={5000} limit={1} />
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}
export default App;